<template>
  <div>
    <div class="content-banner-default container-lg">
      <div class="content-banner-default-bg" v-if="partner.image_banner"
        :style="{ background: `url(${partner.image_banner})` }">
        <div class="content-banner-default-bg-logo">
          <img class="img-fluid" v-if="partner.image_logo" :src="partner.image_logo" alt="logo partner"
            title="logo partner" />
        </div>
      </div>
      <div class="content-banner-default-description">
        <h1 class="title">{{ partner.name }}</h1>
        <div class="content-banner-default-description-div">
          <div class="location">
            <svg xmlns="http://www.w3.org/2000/svg" width="22.489" height="29.985" viewBox="0 0 22.489 29.985">
              <path
                d="M11.244,5.622a5.622,5.622,0,1,0,5.622,5.622A5.628,5.628,0,0,0,11.244,5.622Zm0,9.37a3.748,3.748,0,1,1,3.748-3.748A3.752,3.752,0,0,1,11.244,14.992ZM11.244,0A11.244,11.244,0,0,0,0,11.244c0,4.534,1.579,5.8,10.089,18.135a1.406,1.406,0,0,0,2.311,0c8.509-12.336,10.089-13.6,10.089-18.135A11.244,11.244,0,0,0,11.244,0Zm0,27.755c-8.158-11.8-9.37-12.734-9.37-16.511a9.37,9.37,0,0,1,16-6.626,9.309,9.309,0,0,1,2.744,6.626C20.614,15.021,19.4,15.957,11.244,27.755Z"
                fill="#112d23" />
            </svg>
            <p>{{ partner.concelho }}, {{ partner.distrito }}</p>
          </div>
          <div class="content-banner-default-description-btn">
            <button class="content-banner-default-classification" v-scroll-to="'#avaliation'">
              <div class="content-banner-default-classification-rate">
                <p>{{ partner.rate }}</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="34.657" height="34.171" viewBox="0 0 34.657 34.171">
                  <path
                    d="M35.969,1.176l-4.23,8.835-9.464,1.421a2.154,2.154,0,0,0-1.147,3.644l6.847,6.873-1.619,9.71a2.085,2.085,0,0,0,3.006,2.249l8.467-4.585,8.467,4.585A2.087,2.087,0,0,0,49.3,31.66l-1.62-9.71,6.847-6.873a2.154,2.154,0,0,0-1.147-3.644l-9.464-1.421-4.23-8.835a2.048,2.048,0,0,0-3.718,0Z"
                    transform="translate(-20.5 0.013)" fill="#fff" />
                </svg>
              </div>
              <div class="content-banner-default-classification-comments">
                <p>{{ total_comments }}</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="23.552" height="20.645" viewBox="0 0 23.552 20.645">
                  <path
                    d="M11.8,32C5.283,32,0,36.29,0,41.585a8.5,8.5,0,0,0,2.625,6.023A11.731,11.731,0,0,1,.1,52.021a.358.358,0,0,0-.069.4.355.355,0,0,0,.335.221A10.645,10.645,0,0,0,6.85,50.277a14.045,14.045,0,0,0,4.949.894c6.516,0,11.756-4.292,11.756-9.585S18.315,32,11.8,32Z"
                    transform="translate(-0.002 -32)" fill="#fff" />
                </svg>
              </div>
            </button>
            <button v-show="$route.name == 'PartnerLandingPage'" class="btn-request-contact"
              v-scroll-to="'#form-contacto'">
              Pedido de contacto
            </button>
          </div>
        </div>
        <BtnFavorite class="d-lg-none" :name="partner.name" />
      </div>
    </div>
    <div class="content-partner-img-info-btn d-none d-lg-flex container">
      <BtnFavorite v-show="$route.name !== 'PartnersOther'" :name="partner.name" />
      <SocialSharing :title="partner.name" :description="partner.short_description" class="d-none d-lg-flex" />
    </div>
    <div class="content-partner-img-info-description">
      <TextLineClamp v-show="$route.name !== 'PartnersOther'" :short_description="partner.short_description" />
    </div>
  </div>
</template>

<script>
import TextLineClamp from "@/components/textLineClamp/TextLineClamp";
import SocialSharing from "@/components/socialSharing/SocialSharing.vue";
import BtnFavorite from "@/components/btnFavorite/Index";

export default {
  data() {
    return {
      isSave: false,
    };
  },
  components: {
    TextLineClamp,
    SocialSharing,
    BtnFavorite,
  },
  props: ["partner", "total_comments"],
};
</script>

<style lang="scss" scoped>
.content-banner-default {
  position: relative;

  @media (max-width: 991px) {
    padding: 0 !important;
  }

  &-bg {
    width: 100%;
    height: 450px;
    position: relative;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: cover !important;
    border-radius: 10px 10px 0px 0px;

    @media (max-width: 991px) {
      border-radius: 0;
    }

    &-logo {
      position: absolute;
      bottom: -70px;
      right: 40px;
      padding: 35px;
      background: var(--white);
      border-radius: 10px;

      @media (max-width: 991px) {
        right: 30px;
        bottom: -30px;
      }
    }
  }

  &-description {
    padding: 30px 40px;
    text-align: left;
    background: #f2f2f2;
    border-radius: 0px 0px 10px 10px;

    &-btn {
      display: flex;
      align-self: center;
      justify-content: center;
      gap: 20px;

      button:nth-child(2) {
        width: 258px;
        height: 60px;
        color: white;
        background: var(--green-medium);
        border: 1px solid var(--green-medium);
        border-radius: 10px;
        -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 16%);
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 16%);
        font-size: 22px;
        font-family: "Font Regular";

        &:hover {
          background: white;
          color: var(--green-medium);
          transition: all 0.3s ease;
        }
      }
    }

    @media (max-width: 991px) {
      padding: 65px 40px 45px 40px;
      border-radius: 0;
    }

    .title {
      font-size: 34px;
      font-family: "Font Bold";
      color: var(--green-dark);
      margin-bottom: 30px;

      @media (max-width: 991px) {
        font-size: 24px;
      }
    }

    &-div {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .location {
      display: flex;
      align-items: center;

      @media (max-width: 991px) {
        margin-bottom: 20px;
      }

      svg {
        @media (max-width: 991px) {
          max-width: 16px;
        }
      }

      p {
        font-size: 24px;
        font-family: "Font Regular";
        color: var(--green-dark);
        margin-left: 10px;
        margin-bottom: 0;

        @media (max-width: 991px) {
          font-size: 18px;
        }
      }
    }
  }

  &-classification {
    display: flex;
    align-items: center;
    height: 60px;
    background: #e69c5a;
    border: 1px solid #e69c5a;
    border-radius: 8px;
    padding: 10px 16px;

    @media (max-width: 991px) {
      position: absolute;
      top: 30px;
      right: 30px;
    }

    &-rate {
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: 20px;
      border-right: 1px solid var(--white);

      p {
        font-size: 33px;
        font-family: "Font Bold";
        color: var(--white);
        line-height: 1;
        margin-right: 10px;
        margin-bottom: 0;
      }
    }

    &-comments {
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 20px;

      p {
        font-size: 23px;
        font-family: "Font Regular";
        color: var(--white);
        line-height: 1;
        margin-right: 8px;
        margin-bottom: 0;
      }
    }
  }
}

.content-partner-img {
  width: 100%;
  height: 100%;
  padding: 0;

  img {
    width: 100%;
    max-height: 350px;
    border-radius: 10px;
  }

  &-info {
    display: flex;
    justify-content: flex-start;
    gap: 60px;
    align-items: center;

    @media (max-width: 991px) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 27px;
    }

    &-label {
      display: flex;
      align-items: center;
      gap: 10px;

      p {
        padding: 0;
        margin: 0;
        font-size: 22px;
        font-family: "Font Regular", sans-serif;

        @media screen and (max-width: 991px) {
          font-size: 22px;
        }
      }

      @media screen and (max-width: 991px) {
        svg {
          width: 36px;
          height: 36px;
        }
      }
    }

    &-btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 25px;
      padding-top: 30px;
      padding-bottom: 30px;

      @media screen and (max-width: 991px) {
        justify-content: flex-start;
      }
    }
  }
}
</style>
